import { CollectionName } from '../../lib/sj-orm';
import { DtoId } from '../../lib/sj-orm/models/base.dto';

import { routes } from './routes';

export const DEFAULT_REDIRECT_URL = '/dashboard';
export const SAFE_PATHS_FOR_REDIRECT = [
  '/dashboard',
  '/beneficiaries',
  '/menu',
  '/notifications',
  '/inbox',
  '/assets',
  '/personal-identifiers',
  '/scenarios',
  '/interwill',
  '/contacts',
  '/documents',
  '/delegated',
  '/account',
  '/sowe',
  '/vfo',
];

const CollectionRouter: Partial<Record<CollectionName, (id: string) => string>> = {
  [CollectionName.ASSETS]: routes.asset,
  [CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS]: routes.personalId,
  [CollectionName.PRIVATE_DOCUMENTS]: routes.privateDocument,
  [CollectionName.CONTACTS]: routes.contact,
};

export const getCollectionRoute = (collection: CollectionName, id: DtoId) => {
  const getRoute = CollectionRouter[collection];
  return getRoute ? getRoute(id) : '/not_found';
};

export const isPathSafeForRedirect = (pathname: string) => {
  const dynamicPathRegex = /\[\w+\]/;
  const isInterwill = pathname.match(/\/interwill\/.+/);
  const isDynamicPath = dynamicPathRegex.test(pathname);

  return (
    SAFE_PATHS_FOR_REDIRECT.some((prefix) => pathname.startsWith(prefix)) &&
    !isDynamicPath &&
    !isInterwill
  );
};
